import type { InsulinAverageInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"
import { limitInsulinDigits } from "src/utils/limitInsulinDigits"

export function InsulinAverage(props: TileProps<InsulinAverageInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()
  const days = range / 24

  const { insulinCalculations } = useCalculationsContext()
  const { totalInsulinUnits } = insulinCalculations[range] || {}
  const averageInsulinUnits = totalInsulinUnits === undefined
    ? undefined
    : totalInsulinUnits / days
  const value = limitInsulinDigits(averageInsulinUnits)

  const unit = polyglot.t(
    "unit.units_day",
    isNaN(value) ? 0 : value,
  )

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {isNaN(value) ? "--" : value.toLocaleString(polyglot.locale())}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {unit}
      </TileUnit>
    </>
  )
}
